export default __webpack_public_path__ + "static/media/amenidades.c7ec8590.jpg";